import { createSlice } from '@reduxjs/toolkit'
import { LoginSchema } from '../types/LoginSchema'
import { loginService } from '../services/loginService'
import { resendOtpCode } from '../services/resendOtpCode'
import { loginMFA } from '../services/loginMFA'

const initialState: LoginSchema = {
	isLoading: false,
	error: undefined,

	login: '',
	password: '',
	otpCode: '',
	mfa: undefined,
	mfaLoading: false,
	resendLoading: false
}

export const loginSlice = createSlice({
	name: 'login',
	initialState,
	reducers: {
		resetLoginState: (state) => {
			state.login = ''
			state.password = ''
		},
		setLogin: (state, action) => {
			state.login = action.payload
		},
		setPassword: (state, action) => {
			state.password = action.payload
		},
		setOtpCode: (state, action) => {
			state.otpCode = action.payload
		},
		resetError: (state) => {
			state.error = undefined
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(loginService.pending, (state) => {
				state.isLoading = true
				state.error = undefined
			})
			.addCase(loginService.fulfilled, (state, action) => {
				state.isLoading = false
				state.mfa = action.payload
			})
			.addCase(loginService.rejected, (state, action) => {
				state.isLoading = false
				state.error = { message: action.payload }
			})
			.addCase(loginMFA.pending, (state) => {
				state.mfaLoading = true
				state.error = undefined
			})
			.addCase(loginMFA.fulfilled, (state) => {
				state.mfaLoading = false
			})
			.addCase(loginMFA.rejected, (state, action) => {
				state.mfaLoading = false
				state.error = {
					message: action.payload?.message,
					errorStatus: action.payload?.errorStatus
				}
			})
			.addCase(resendOtpCode.pending, (state) => {
				state.resendLoading = true
				state.error = undefined
			})
			.addCase(resendOtpCode.fulfilled, (state) => {
				state.resendLoading = false
			})
			.addCase(resendOtpCode.rejected, (state, action) => {
				state.resendLoading = false
				state.error = {
					message: action.payload?.message,
					errorStatus: action.payload?.errorStatus
				}
			})
	}
})

export const loginActions = loginSlice.actions
export const loginReducer = loginSlice.reducer
